// extracted by mini-css-extract-plugin
export default {"card":"styles_card__tV53O","header":"styles_header__itgEd","close":"styles_close__SNpNz","uniforms":"styles_uniforms__F520e"};